import React from "react";
import {Dialog} from 'primereact/dialog';
import {ProgressSpinner} from 'primereact/progressspinner';



export var showProgress = function () {
    this.setState({open: true});
};
export var hideProgress = function () {
    this.setState({open: false});
};

class ProgressCustom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        showProgress = showProgress.bind(this);
        hideProgress = hideProgress.bind(this);
    }

    render() {
        return (
            <div>
                <Dialog showHeader={false} className={"progressCustom"}
                        style={{boxShadow: "none"}}
                        contentStyle={{backgroundColor: "rgb(0,0,0,0)", border: "none", boxShadow: "none"}}
                        visible={this.state.open}
                        onHide={hideProgress}
                >
                    <ProgressSpinner/>

                </Dialog>
            </div>
        );
    }
}

export default (ProgressCustom);
